import { useMemo } from 'react';
import { CalendarEvent } from '../utils/eventUtils';

interface ExecutorDisplay {
  nome: string;
  avatar: string;
}

interface UseEventCardDisplayReturn {
  atividadesLabel: string;
  executorCount: number;
  firstExecutor: ExecutorDisplay | undefined;
  displayExecutors: ExecutorDisplay[];
}

export const useEventCardDisplay = (event: CalendarEvent): UseEventCardDisplayReturn => {
  const atividadesLabel = useMemo(() => {
    const qtd = event.qtdAtividades ?? 0;
    const word = qtd === 1 ? 'atividade' : 'atividades';
    return `${qtd} ${word} (${event.horasPrevistas})`;
  }, [event.qtdAtividades, event.horasPrevistas]);

  const executorCount = event.executor?.length ?? 0;
  const firstExecutor = executorCount === 1 ? event.executor[0] : undefined;
  const displayExecutors = useMemo(() => (event.executor ? event.executor.slice(0, 3) : []), [event.executor]);

  return {
    atividadesLabel,
    executorCount,
    firstExecutor,
    displayExecutors,
  };
};
